let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8h7gn")).then(() => parcelRequire('5RvEg'));